module.exports = __webpack_public_path__ + "img/badge-most-created-leads-keyvue-blue.9dd38aa2.png";